import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import IntegrationPopupWindow from './components/IntegrationPopupWindow/IntegrationPopupWindow';

const root = ReactDOM.createRoot(document.getElementById('root'));

const isPopup = window.location.pathname.startsWith('/integration-popup-window/');

root.render(
  <React.StrictMode>
    {isPopup ? <IntegrationPopupWindow /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
